var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-flow"},[_c('div',{staticClass:"echart-progress"},[_c('el-progress',{attrs:{"type":"dashboard","percentage":_vm.usedFlow,"color":_vm.colors,"stroke-width":10}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }